import {
	ResponsiveContainer,
	XAxis,
	YAxis,
	Tooltip,
	LabelList,
	ScatterChart,
	Scatter,
	Label,
	ZAxis,
	ReferenceLine,
	Legend,
} from "recharts";
import { SelectPicker, CheckPicker, Checkbox } from "rsuite";
import { numberFormatter } from "../../utils";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@rsuite/icons/Close";
import { borderRadius, width } from "@mui/system";
import {
	drillDownType,
	supplierDrillDownType,
	districtDrillDownType,
} from "../constants";
import GrossMarginChart1 from "./grossMarginChart1";
import GrossMarginChart2 from "./grossMarginChart2";
import { Segmented } from "antd";

const PerformanceScatter = (props: any) => {
	const data = props.data;
	const refX = props.refX;
	const refY = props.refY;
	const selected = props.recommended;
	const viewBy = props.view;
	const {
		selectedViewBy,
		legendColors,
		detailView,
		updateDetailview,
		updatePerformanceGraphData,
		benchmarkingDataFlag,
	} = props;

	const highlight = props.highlight;
	const {
		selectedSupplierCount,
		viewFor,
		activeTab,
		performanceFlag,
		selectedFilters,
		selectedScatter,
		commoditySupplier,
		filters,
	} = props;

	const footerStyles = {
		padding: "10px 2px",
		borderTop: "1px solid #e5e5e5",
	};

	const [toolTipData, setToolTipData] = useState(null);
	const [growthOrRebateView, setGrowthOrRebateView] = useState("growth");
	const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

	const [selectedDrillDownType, setSelectedDrillDownType] = useState(
		drillDownType.length && drillDownType[2].value
	);

	const [selectedSupplierDrillDownType, setSelectedSupplierDrillDownType] =
		useState(
			supplierDrillDownType.length && supplierDrillDownType[0].value
		);

	const [selectedDistrictDrillDownType, setSelectedDistrictDrillDownType] =
		useState(
			districtDrillDownType.length && districtDrillDownType[0].value
		);

	/* on changing drill down type */
	const drillDownTypeHandler = (e: any) => {
		setSelectedDrillDownType(e === null ? "all" : e);
	};

	/* on changing supplier drill down type */
	const supplierDrillDownTypeHandler = (e: any) => {
		setSelectedSupplierDrillDownType(e === null ? "all" : e);
	};

	/* on changing district drill down type */
	const districtDrillDownTypeHandler = (e: any) => {
		setSelectedDistrictDrillDownType(e === null ? "all" : e);
	};

	const handleDrillDownSelection = () => {
		if (viewBy == "L3" && selectedDrillDownType != "all") {
			props.handleDrillDownSelection(selectedDrillDownType, toolTipData);
		} else if (
			viewBy == "Supplier" &&
			selectedSupplierDrillDownType != "all"
		) {
			props.handleDrillDownSelection(
				selectedSupplierDrillDownType,
				toolTipData
			);
		} else if (
			viewBy == "District" &&
			selectedDistrictDrillDownType != "all"
		) {
			props.handleDrillDownSelection(
				selectedDistrictDrillDownType,
				toolTipData
			);
		}
	};

	// Handle scatter point click
	const handleScatterHover = (data: any, event: any) => {
		setToolTipData(data.payload); // Store the clicked point's data
		setPopupPosition({ x: data?.cx, y: data?.cy }); // Get mouse position
		event.stopPropagation();
	};

	// Close the popup
	const closePopup = () => {
		setToolTipData(null);
	};

	const handleScatterClick = (data: any) => {
		console.log(data.category, selectedScatter);
		if (data.category === selectedScatter) {
			props.handleClick(null);
			if (activeTab == "district") {
				// props.filterUpdate([], "district");
				props.getSummary("District", null, []);
			} else if (activeTab == "supplier") {
				// props.filterUpdate([data.category], "supplier");
				props.getSummary("Supplier", []);
			}
		} else {
			props.handleClick(data.category);
			if (activeTab == "district") {
				// props.filterUpdate([data.category], "district");
				props.getSummary("District", null, [data.category]);
			} else if (activeTab == "supplier") {
				// props.filterUpdate([data.category], "supplier");
				props.getSummary("Supplier", [data.category]);
			}
		}
	};
	console.log(selectedScatter);

	const renderCustomLegend = (data: any) => {
		const { payload } = data;
		// name= {d.color == legendColors.electrical ? 'Electrical' :
		// d.color == legendColors.dataCommunication? 'Data Communication' :
		// d.color == legendColors.lighting? 'Lighting' :
		// d.color == legendColors.mro? 'MRO' : ''
		// }
		return (
			<ul className="custom-legend flex justify-center">
				{Object.keys(legendColors).map((entry: any, index: any) => (
					<div
						className="flex items-center"
						key={`item-${index}`}
						style={{
							color: legendColors[entry],
							marginLeft: 5,
							fontSize: "1.8vh",
						}}
					>
						<div
							style={{
								backgroundColor: legendColors[entry],
								width: "1.3vh",
								height: "1.3vh",
								marginRight: 5,
							}}
						/>
						<span className="mr-[1vh] textSmall">
							{legendColors[entry] == legendColors.electrical
								? "Electrical"
								: legendColors[entry] ==
								  legendColors.dataCommunication
								? "Data Communication"
								: legendColors[entry] == legendColors.lighting
								? "Lighting"
								: legendColors[entry] == legendColors.mro
								? "MRO"
								: ""}
						</span>
					</div>
				))}
			</ul>
		);
	};

	const customTooltipNormal = (data: any) => {
		let payload = data.payload;
		if (payload && payload.length) {
			const data = payload[0].payload;
			const popupStyle: any = {
				// position: "absolute",
				width: "12vw",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				cursor: "pointer",
				color: "black",
			};

			return (
				<div style={popupStyle}>
					<div className="w-full flex justify-between h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">
							{data?.category}
						</div>
					</div>
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Gross Margin:{" "}
							</label>
							<label
								className="graph-label"
								style={{
									color: "#3f3f3f",

									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.grossMargin, 2)}%
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label"
								style={{
									color: "#5a5a5a",

									fontWeight: "normal",
								}}
							>
								5 Year CAGR:{" "}
							</label>
							<label
								className="graph-label"
								style={{
									color: "#3f3f3f",

									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.cagr, 2)}%
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label"
								style={{
									color: "#5a5a5a",

									fontWeight: "normal",
								}}
							>
								Spend:{" "}
							</label>
							<label
								className="graph-label"
								style={{
									color: "#3f3f3f",

									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.cost, 0, "$")}
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label"
								style={{
									color: "#5a5a5a",

									fontWeight: "normal",
								}}
							>
								Sales:{" "}
							</label>
							<label
								className="graph-label"
								style={{
									color: "#3f3f3f",

									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.revenue, 0, "$")}
							</label>
						</p>
					</div>
				</div>
			);
		}
	};

	  const fillColor = (data: any) => {
    if (data.color != "white" && data.color) {
      return data.color;
    } else if (data.type == "growthPotential") {
      return "#c79c38";
    } else if (data.type == "lowPerformers") {
      return "#d55454";
    } else if (data.type == "growCategory") {
      return "#008b00";
    } else {
      return "#60b5bf";
    }
  };

	const getInitials = (str: any) => {
		// Remove extra spaces and split by space
		const words = str.trim().split(/\s+/);
		if (words.length >= 2) {
			// Take first letter of first two words
			return words[0][0] + words[1][0];
		} else if (words.length === 1 && words[0].length >= 2) {
			// Take first two letters of the single word
			return words[0].substring(0, 2);
		} else if (words.length === 1) {
			// If only one letter in the word, return it
			return words[0];
		}
		return "";
	};

	const renderCustomizedLabel = (props: any, d: any) => {
		const { x, y, width, value, name } = props;
		return (
			<>
				{viewFor?.length === 0 && viewBy !== "District" && (
					<text
						x={x + width / 2}
						y={y - 10}
						fill="#fff"
						fontSize={10}
						textAnchor="middle"
						dominantBaseline="middle"
					>
						{d.length > 10 ? d.slice(0, 10) + "..." : d}
					</text>
				)}
				{viewFor?.length !== 0 &&
					viewBy !== "District" &&
					viewFor?.includes(d) && (
						<text
							x={x + width / 2}
							y={y - 10}
							fill="#fff"
							fontSize={10}
							textAnchor="middle"
							dominantBaseline="middle"
						>
							{d.length > 10 ? d.slice(0, 10) + "..." : d}
						</text>
					)}
				{viewFor?.length === 0 && viewBy === "District" && (
					<text
						x={x + width / 2}
						y={y + 10}
						fill="#fff"
						fontSize={10}
						textAnchor="middle"
						dominantBaseline="middle"
						className="pointer-events-none"
					>
						{getInitials(d)}
					</text>
				)}
				{viewFor?.length !== 0 &&
					viewBy === "District" &&
					viewFor?.includes(d) && (
						<text
							x={x + width / 2}
							y={y + 10}
							fill="#fff"
							fontSize={10}
							textAnchor="middle"
							dominantBaseline="middle"
						>
							{getInitials(d)}
						</text>
					)}
			</>
		);
	};

	console.log(filters, "filters");
	const getResponsiveContainerHeight = () => {
		if (activeTab === "supplier") {
			return props.isVisible ? "61%" : "71%";
		} else if (activeTab === "district") {
			return props.isVisible ? "58%" : "69%";
		} else if (activeTab === "category") {
			return props.isVisible ? "70%" : "78%";
		}
		return props.isVisible ? "60%" : "70%";
	};

	const [activeTooltip, setActiveTooltip] = useState(false);
	return (
		<div className="w-full h-full px-3">
			<div className="flex justify-between headSpace !h-[6vh]">
				<div className="ml-[1vh] headContent font-bold  text-[2vh] text-black">
					Peer Comparison{" "}
					{performanceFlag && (
						<span className="font-light italic text-[1.5vh] flex-nowrap">
							(Selected Supplier: {selectedFilters["supplier"][0]}
							)
						</span>
					)}
				</div>
				{activeTab === "supplier" &&
					props?.selectedFilters?.supplier?.length > 0 && (
						<div className="flex justify-between">
							<div className="flex gap-x-[1vh] mt-[0.5vh]">
								<Segmented
									options={[
										{
											label: "District",
											value: "District",
										},
										{ label: "Category", value: "L3" },
										{
											label: "Supplier Benchmarking",
											value: "Supplier Benchmarking",
										},
									]}
									value={viewBy}
									onChange={(val) => {
										props.updateViewBy(val);
										if (val === "Supplier Benchmarking") {
											props.getBenchmarkingFilters();
											props.updatePerformanceFlag(true);
										} else {
											props.updatePerformanceFlag(false);
										}
									}}
								/>
							</div>
							{[
								"L3",
								"District",
								"Supplier Benchmarking",
							].includes(viewBy) &&
								activeTab === "supplier" && (
									<button
										className="ml-[1vw] underline text-black textNormal font-[500]"
										onClick={() => {
											props.updateViewBy("Supplier");
											props.updateHighlight(null);
											props.updatePerformanceFlag(false);
											props.updateSelectedFilters(
												{
													...props.selectedFilters,
													supplier: [],
													district: [],
												},
												"Supplier"
											);
										}}
									>
										Drill Up
									</button>
								)}
						</div>
					)}

				{activeTab === "district" &&
					props?.selectedFilters?.district?.length > 0 && (
						<div className="flex justify-between">
							<div className="flex gap-x-[1vh] mt-[0.5vh]">
								<Segmented
									options={[
										{
											label: "Supplier",
											value: "Supplier",
										},
										{ label: "Category", value: "L3" },
									]}
									value={viewBy}
									onChange={(val) => {
										props.updateViewBy(val);
									}}
								/>
							</div>
							{["L3", "Supplier"].includes(viewBy) &&
								activeTab === "district" && (
									<button
										className="ml-[1vw] underline text-black textNormal font-[500]"
										onClick={() => {
											props.updateHighlight(null);
											props.updateViewBy("District");
											props.updateSelectedFilters(
												{
													...props.selectedFilters,
													district: [],
													supplier: [],
												},
												"District"
											);
										}}
									>
										Drill Up
									</button>
								)}
						</div>
					)}

				{activeTab === "category" && (
					<>
						<div className="flex justify-between">
							<div className="flex gap-x-[1vh] mt-[0.5vh]">
								{/* Main Segmented Control */}
								<Segmented
									options={[
										{ label: "L1", value: "L1" },
										{ label: "L2", value: "L2" },
										{ label: "L3", value: "L3" },
										...(selectedFilters.l3.length === 1
											? [
													{
														label: "Detail View",
														value: "Supplier",
													},
											  ]
											: []),
									]}
									value={viewBy}
									onChange={(val: any) => {
										props.updateViewBy(val);
										updateDetailview(val === "Supplier");
									}}
								/>

								{/* Supplier/District Segment */}
								{selectedFilters.l3.length === 1 &&
									detailView && (
										<Segmented
											options={[
												{
													label: "Supplier",
													value: "Supplier",
												},
												{
													label: "District",
													value: "District",
												},
											]}
											value={viewBy}
											onChange={(val: any) => {
												props.updateViewBy(val);
											}}
										/>
									)}
							</div>

							{/* Drill Up Button */}
							{(viewBy === "Supplier" || viewBy === "District") &&
								activeTab === "category" && (
									<button
										className="ml-[1vw] underline text-black textNormal font-[500]"
										onClick={() => {
											props.updateViewBy("L3");
											props.updateHighlight(null);
											updateDetailview(false);
											props.updateSelectedFilters(
												{
													...props.selectedFilters,
													l3: [],
													supplier: [],
													district: [],
												},
												"L3"
											);
										}}
									>
										Drill Up
									</button>
								)}
						</div>
					</>
				)}

				{performanceFlag && selectedFilters?.l1B?.length > 0 && (
					<div className="flex justify-end mr-[2vh] h-fit">
						<div className="flex gap-x-[2vh] ml-[1vh] not-italic mt-[1vh] h-[4vh]">
							{["growth", "rebate"].map((item: string, idx) => {
								return (
									<button
										key={item}
										onClick={() => {
											setGrowthOrRebateView(item);
										}}
										className={`nav-items flex justify-center items-center border-l border-r border-[#bebebe] ${
											viewBy === item
												? "selected bg-[#f2f4f7] font-semibold"
												: "bg-white font-normal"
										} text-black w-fit py-[1vh] px-[2vh] h-[4vh]`}
									>
										<span className="font-normal text-[0.8vw]">
											{item == "growth"
												? "Margin vs CAGR"
												: "Margin vs Rebate"}
										</span>
									</button>
								);
							})}
						</div>
					</div>
				)}
			</div>
			<div className="flex justify-end items-center mr-4 ">
				{activeTab == "supplier" && (
					<div className="flex flex-col min-w-[8vw] max-w-[8vw]">
						{!performanceFlag ? (
							<SelectPicker
								data={
									props?.filters["supplier"]?.length
										? props?.filters["supplier"]
										: []
								}
								placeholder={
									performanceFlag
										? "Peer Supplier"
										: "Supplier"
								}
								labelKey={
									performanceFlag
										? "master_vendor_name"
										: "vendor"
								}
								valueKey={
									performanceFlag
										? "master_vendor_name"
										: "vendor"
								}
								virtualized
								value={
									selectedFilters["supplier"]
										? selectedFilters["supplier"][0]
										: []
								}
								onChange={(value: any) => {
									props.handleClick(null);
									if (value != null) {
										props.handleClick(value);
										if (!performanceFlag) {
											props.updateViewBy("District");
										}
										updatePerformanceGraphData([]);
										props.filterUpdate([value], "supplier");
										props.getSummary("District", [value]);
									} else {
										props.updateSelectedFilters(
											{
												...props.selectedFilters,
												supplier: [],
												district: [],
											},
											"Supplier"
										);
										props.updateViewBy("Supplier");
									}
								}}
								onClean={() => {
									props.updateViewBy("Supplier");
									props.updatePerformanceFlag(false);
									props.updateSelectedFilters(
										{
											...props.selectedFilters,
											supplier: [],
											district: [],
										},
										"Supplier"
									);
								}}
							/>
						) : (
							<CheckPicker
								data={
									props?.filters["supplierB"]?.length
										? props?.filters["supplierB"]
										: []
								}
								placeholder="All"
								labelKey="vendor"
								valueKey="vendor"
								virtualized
								value={
									selectedFilters?.supplierB?.length
										? selectedFilters?.supplierB
										: []
								}
								onChange={(value: any) =>
									props.filterUpdate(value, "supplierB")
								}
								onClean={() => {
									props.handleClean("supplierB");
								}}
								renderExtraFooter={() => (
									<div style={footerStyles}>
										<Checkbox
											indeterminate={
												selectedFilters?.supplierB
													?.length > 0 &&
												selectedFilters?.supplierB
													?.length <
													props?.filters?.supplierB
														?.length
											}
											checked={
												selectedFilters?.supplierB
													?.length ===
												props?.filters?.supplierB
													?.length
											}
											onChange={(value: any) =>
												props.filterUpdate(
													"all",
													"supplierB"
												)
											}
										>
											Check all
										</Checkbox>
									</div>
								)}
							/>
						)}
					</div>
				)}
				{activeTab == "district" && (
					<div className="flex flex-col min-w-[4vw] max-w-[6vw] mr-6">
						<SelectPicker
							data={
								props.filters["district"].length
									? props.filters["district"]
									: []
							}
							placeholder="District"
							labelKey={"district"}
							valueKey={"district"}
							value={
								selectedFilters["district"]
									? selectedFilters["district"][0]
									: []
							}
							onChange={(value: any) => {
								props.handleClick(value, true);
								props.updateViewBy("Supplier");
								if (value != null) {
									props.getSummary(
										"Supplier",
										null,
										[value],
										true
									);
								}
							}}
							onClean={() => {
								props.updateViewBy("District");
								props.updateSelectedFilters(
									{
										...props.selectedFilters,
										district: [],
										supplier: [],
									},
									"District"
								);
							}}
						/>
					</div>
				)}
			</div>

			{performanceFlag ? (
				benchmarkingDataFlag ? (
					selectedFilters?.l1B?.length > 0 && !commoditySupplier ? (
						growthOrRebateView == "growth" ? (
							<GrossMarginChart1
								selectedVendor={selectedFilters?.supplier}
								selectedMaskStatus={1}
								performanceGraphData={
									props?.performanceGraphData
								}
								supplier={selectedFilters?.supplierB}
							/>
						) : (
							<GrossMarginChart2
								selectedVendor={selectedFilters?.supplier}
								selectedMaskStatus={1}
								performanceGraphData={
									props?.performanceGraphData
								}
								supplier={selectedFilters?.supplierB}
							/>
						)
					) : (
						<div className="h-full w-full flex justify-center text-center items-center text-[2vh]">
							<div>
								{commoditySupplier ? (
									<span>
										{filters?.l1B?.length > 1
											? "Please select different L1"
											: "Please select a non-commodity supplier"}
									</span>
								) : (
									<>
										<span>
											Peer Benchmarking available only at
											L1 Level
										</span>{" "}
										<br />
										<span className="italic text-[1.5vh]">
											(Please select the L1 to see Peer
											Suppliers)
										</span>
									</>
								)}
							</div>
						</div>
					)
				) : (
					<div className="h-full w-full flex justify-center text-center items-center text-[2vh]">
						Benchmarking data is not avilable for this Supplier
					</div>
				)
			) : (
				<ResponsiveContainer
					style={{ backgroundColor: "#fff" }}
					id="capture-area"
					width="100%"
					height={getResponsiveContainerHeight()}
				>
					<ScatterChart
						margin={{
							top: 40,
							right: 80,
							bottom: 20,
							left: 30,
						}}
						onClick={() => {
							setActiveTooltip(false);
						}}
					>
						<XAxis
							type="number"
							dataKey="cagr"
							className="graph-label"
							stroke="black"
							unit="%"
							domain={["dataMin - 3", "dataMax + 3"]}
							tickFormatter={(val) =>
								`${numberFormatter(val, 0)}`
							}
						>
							<Label
								className="graph-label-new"
								value="5-year CAGR"
								offset={0}
								position="bottom"
								style={{ fill: "#000" }}
							/>
						</XAxis>
						<YAxis
							className="graph-label"
							stroke="black"
							dataKey="grossMargin"
							unit="%"
							domain={["dataMin - 5", "dataMax + 5"]}
							tickFormatter={(val) =>
								`${numberFormatter(val, 0)}`
							}
						>
							<Label
								className="graph-label-new"
								value="Gross Margin (%)"
								angle={-90}
								position="insideLeft"
								style={{ fill: "#000", textAnchor: "middle" }}
							/>
						</YAxis>
						<ZAxis
							type="number"
							dataKey="revenue"
							range={data?.length <= 10 ? [100, 2000] : [50, 500]}
						></ZAxis>

						<ReferenceLine
							x={refX}
							label={{
								position: "top",
								fill: "#ce9178",
								value: numberFormatter(refX, 2) + "%",
								fontStyle: "italic",
							}}
							stroke="black"
							strokeDasharray="5 3"
							opacity={0.3}
						/>

						<ReferenceLine
							y={refY}
							label={{
								position: "right",
								fill: "#ce9178",
								value: numberFormatter(refY, 2) + "%",
								fontStyle: "italic",
							}}
							stroke="black"
							strokeDasharray="5 3"
							opacity={0.3}
						/>

						{
							<Tooltip
								contentStyle={{
									color: "black",
									backgroundColor: "rgb(26, 25, 22)",
								}}
								cursor={{ strokeDasharray: "3 3" }}
								content={customTooltipNormal}
							/>
						}

						{data?.map((d: any, index: number) => {
							if (
								d.cagr > refX + 50 ||
								d.cagr < refX - 50 ||
								d.grossMargin <= refY - 50 ||
								d.grossMargin >= refY + 50
							) {
								return null;
							}
							return (
								<>
									<Scatter
										key={index}
										data={[d]}
										fill={fillColor(d)}
										onClick={handleScatterClick}
										onMouseEnter={(e) => {
											// e.stopPropagation()
											// setToolTipData(e);
											setActiveTooltip(true);
										}}
										opacity={
											selected == null && !highlight
												? 1
												: highlight == d.category &&
												  selectedViewBy === viewBy
												? 1
												: highlight &&
												  selectedViewBy !== viewBy
												? 1
												: 0.3
										}
									>
										{((selectedSupplierCount === 10 &&
											viewBy == "Supplier") ||
											viewBy === "District") && (
											<LabelList
												dataKey={d.category}
												content={(ele: any) =>
													renderCustomizedLabel(
														ele,
														d.category
													)
												}
											/>
										)}
									</Scatter>
								</>
							);
						})}
					</ScatterChart>
				</ResponsiveContainer>
			)}
			<div className="contentFooter flex justify-between items-center px-1 py-2">
				<div>
					{renderCustomLegend({
						payload: Object.keys(legendColors).map((key) => ({
							color: legendColors[key],
						})),
					})}
				</div>
				<div className="text-[#666666] italic textXSmall ">
					*The 2x2 Data is at a overall Project Type level
					{activeTab === "supplier" && (
						<span className="ml-3">
							*Includes only suppliers with extracted contracts
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default PerformanceScatter;
